import { Injectable } from '@angular/core';
import { AuthAssetsService } from './auth-assets.service';
import { CanActivate, Router } from '@angular/router';
import { RoutesPath } from '../../routes-path';

@Injectable()
export class AuthLoginGuardService implements CanActivate {
  constructor(public authAssets: AuthAssetsService, public router: Router) {}

  canActivate(): boolean {
    if (this.authAssets.isAuthenticated()) {
      // if you have token, you can't go to 'welcome', 'login','register', 'resetPass', 'notFound'
      this.router.navigate([RoutesPath.default.home]);
      return false;
    }
    return true;
  }
}
